import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonService } from 'wire-frame';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  private apiUrl: string;

  constructor(private http: HttpClient, private common: CommonService, private apiService: ApiService) {
    this.apiUrl = this.apiService.getBaseUrl();
  }

  private getAuthHeaders() {
    const token = localStorage.getItem('jwtToken');
    return {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      })
    }
  }

  getCollections(filters: any) {
    return this.http.get(this.apiUrl + '/reports/collections', {
      params: filters, ...this.getAuthHeaders()
    });
  }

  exportCollections(filters: any) {
    return this.http.get(
      `${this.apiUrl}/reports/collections/export`,
      {
        params: filters,
        responseType: 'blob',
        ...this.getAuthHeaders()
      }
    );
  }

  getDailyPatientDetails(payload: any) {
    return this.http.get(this.apiUrl + '/reports/collections/details', {
      params: payload, ...this.getAuthHeaders()
    });
  }

  getPatientPaymentLedger(patientId: number) {
    return this.http.get(`${this.apiUrl}/patients/${patientId}/payments`, this.getAuthHeaders());
  }

  getPatientPayments(filters: any) {
    return this.http.get(this.apiUrl + '/reports/collections/patients', {
      params: filters, ...this.getAuthHeaders()
    });
  }

  exportPatientPayments(filters: any) {
    return this.http.get(
      `${this.apiUrl}/reports/collections/patients/export`,
      {
        params: filters,
        responseType: 'blob',
        ...this.getAuthHeaders()
      }
    );
  }

  exportDailyPatientDetails(filters: any) {
    return this.http.get(
      `${this.apiUrl}/reports/collections/details/export`,
      {
        params: filters,
        responseType: 'blob',
        ...this.getAuthHeaders()
      }
    );
  }

  getCollectionsPinStatus() {
    return this.http.get(this.apiUrl + '/reports/pin', this.getAuthHeaders());
  }

  setCollectionsPin(body: { pin: string; pin_confirmation: string; current_pin?: string; password?: string }) {
    return this.http.post(this.apiUrl + '/reports/pin', body, this.getAuthHeaders());
  }

  verifyCollectionsPin(pin: string) {
    return this.http.post(this.apiUrl + '/reports/pin/verify', { pin }, this.getAuthHeaders());
  }

  lockCollectionsPin() {
    return this.http.post(this.apiUrl + '/reports/pin/lock', {}, this.getAuthHeaders());
  }
}
